export default __webpack_public_path__ + "static/media/feux_rouges.940d2049.jpg";